import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewContactOutDto,
  EditContactOutDto,
  DeleteContactOutDto,
  GetOneContactOutDto,
  GetAllContactsOutDto,
} from '../types/contact.dto'

export class ErrorContact extends Error {}
const path = '/contact'
class Contact {
  public new(payload: NewContactOutDto) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idContact, body }: EditContactOutDto) {
    return action
      .Patch({
        url: `${path}/${idContact}`,
        body,
      })
      .then(response => {
        return { response, error: null }
      })
      .catch(error => {
        return { error, response: null }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllContactsOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idContact }: GetOneContactOutDto) {
    return action
      .Get({
        url: `${path}/${idContact}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idContact }: DeleteContactOutDto) {
    return action
      .Del({
        url: `${path}/${idContact}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const content = new Contact()
export default content
